var palladium = "/static/980126127f5b5175.png";

export { palladium as default };
//# sourceMappingURL=palladium.png.js.map
